export default __webpack_public_path__ + "static/media/OST.0a401169.png";